import { forwardRef } from "react";
import { MultiSelect } from "@mantine/core";
import useIsDesktop from "../../../hooks/useIsDesktop";

const CustomMultiSelect = forwardRef(
  (
    {
      labelProps = {
        style: { fontWeight: "700" },
        className: "text-neutral-500",
      },
      comboboxProps,
      size,
      ...props
    },
    ref
  ) => {
    const isDesktop = useIsDesktop();
    const responsiveSize = size ?? (isDesktop ? "md" : "sm");
    const safeComboboxProps = {
      position: "bottom",
      hideDetached: false,
      keepMounted: false,
      middlewares: { flip: false, shift: false },
      ...comboboxProps,
    };

    return (
      <MultiSelect
        ref={ref}
        labelProps={labelProps}
        comboboxProps={safeComboboxProps}
        size={responsiveSize}
        {...props}
      />
    );
  }
);

export default CustomMultiSelect;
